import { mergeClasses } from '@fluentui/react-components';

import { useStyles as usePageStyles } from '../GraderPage.style';

import type { GraderListItemProps } from './GraderListItem.interface';

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
function formatDate(iso: string, includeYear = false): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' } : {}),
  });
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------
export function GraderListItem({
  judge,
  isActive,
  onSelect,
}: GraderListItemProps) {
  const pageStyles = usePageStyles();

  return (
    <div
      className={mergeClasses(
        pageStyles.judgeListItem,
        isActive && pageStyles.judgeListItemActive,
      )}
      onClick={() => onSelect(judge.id)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onSelect(judge.id);
        }
      }}
    >
      <div className={pageStyles.judgeListItemHeader}>
        <span className={pageStyles.judgeListItemName}>
          {judge.displayName ?? judge.name}
        </span>
      </div>
      <div className={pageStyles.judgeListItemMeta}>
        {judge.sourceCheckedInAt ? (
          <span>
            Last Modified on {formatDate(judge.sourceCheckedInAt, true)}
          </span>
        ) : judge.createdAt ? (
          <span>Created {formatDate(judge.createdAt)}</span>
        ) : null}
      </div>
    </div>
  );
}
